import { Validators } from "@angular/forms";
import { IFormKey } from "src/app/modules/shared/models/forms";

export const prev_modify_referent_form_template = {
  employerCode: null,
  phone: null,
  surname: null,
  fax: null,
  name: null,
  email: null,
  active: null,
  automaticSend: null
};

export const prev_modify_referent_form_validators = {
  employerCode: [Validators.required],
  phone: [Validators.required],
  surname: [Validators.required],
  fax: [Validators.required],
  name: [Validators.required],
  email: [Validators.required, Validators.email],
  active: [],
  automaticSend: [],
};

export const prev_modify_referent_form_keys: IFormKey[] = [
  {
    id: 'employerCode',
    label: 'Codice datore',
    controlName: 'employerCode',
    type: 'INPUT',
    css: 'col-4',
    readonly: true,
  },
  {
    id: 'phone',
    label: 'Telefono',
    controlName: 'phone',
    type: 'INPUT',
    css: 'col-4',
  },
  {
    id: 'surname',
    label: 'Cognome',
    controlName: 'surname',
    type: 'INPUT',
    css: 'col-4',
  },
  {
    id: 'fax',
    label: 'FAX',
    controlName: 'fax',
    type: 'INPUT',
    css: 'col-4',
  },
  {
    id: 'name',
    label: 'Nome',
    controlName: 'name',
    type: 'INPUT',
    css: 'col-4',
  },
  {
    id: 'email',
    label: 'E-mail',
    controlName: 'email',
    type: 'INPUT',
    css: 'col-4',
  },
  {
    id: 'active',
    label: 'Attivo?',
    controlName: 'active',
    type: 'CHECKBOX',
    css: 'col-2',
  },
  {
    id: 'automaticSend',
    label: 'Invio automatico?',
    controlName: 'automaticSend',
    type: 'CHECKBOX',
    css: 'col-2',
  }
];
